import { gray3, gray4, gray6, mainColor, white } from "assets/styleUtils";
import { Header } from "components";
import { ICompanySpot } from "data/company";
import { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { selectListState } from "recoil/company";
import { getParameterObject } from "utils/common";
import SelectionItem from "./SelectionItem";
import styles from "./style.module.css";

export interface ISelect {
  no: number;
  name?: string;
  title?: string;
  type?: string;
  reservation_type?: string;
  reservation_url?: string;
}

export default function SelectSpotPage() {
  const navigation = useNavigate();
  const { search } = useLocation();
  const { category, contructor_no } = getParameterObject({ url: search });

  const recoilSelectValue = useRecoilValue(selectListState);
  const setRecoilSelect = useSetRecoilState(selectListState);
  const decodeCategory = decodeURIComponent(category);
  const [select, setSelect] = useState<ISelect[]>(
    recoilSelectValue.spotCheckData || [],
  );

  return (
    <>
      <div style={{ padding: "20px", margin: "10px 0" }}>
        <div>
          <h2>지점선택</h2>
          <div style={{ marginBottom: "120px" }}>
            {(recoilSelectValue.spotList || []).map((spot, index) => {
              return (
                <div key={index}>
                  <SelectionItem
                    key={index}
                    title={spot.name}
                    isSelected={select.some((item) => item.no === spot.no)}
                    onClick={() =>
                      setSelect(select.includes(spot) ? [] : [spot])
                    }
                  />

                  <div className={styles.underBar} />
                </div>
              );
            })}
          </div>
        </div>

        <nav className={styles.nav}>
          <div
            className={`${styles.flexCenter} ${styles.buttonStyle}`}
            style={{
              backgroundColor: select.length > 0 ? mainColor : gray6,
              color: select.length > 0 ? white : gray4,
            }}
            onClick={() => {
              if (select.length > 0) {
                if (
                  select[0].reservation_type === "kakao" ||
                  select[0].reservation_type === "site"
                ) {
                  return window.open(select[0].reservation_url);
                } else {
                  setRecoilSelect((prev) => ({
                    ...prev,
                    spotCheckData: select,
                  })),
                    decodeCategory === "예복" || decodeCategory === "한복"
                      ? navigation(
                          `/company/detail/SelectClothes?category=${category}&contructor_no=${contructor_no}`,
                        )
                      : navigation(
                          `/company/detail/insertEntryInfoPage?no=${contructor_no}`,
                        );
                }
              }
            }}
          >
            선택
          </div>
        </nav>
      </div>
    </>
  );
}
